import { SiteSummaryModel } from '../../microsoft/sharepoint/site-summary-model';

export class WebApplicationSummaryModel {
  id: string;
  displayName: string;
  sites: SiteSummaryModel[];
}
